import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import ProfileCard from "../components/ProfileCard";
import NotFound from "./NotFound";
import { API } from "../App";

const titleFor = (cat, loc) => {
  if (cat && loc) return `${cat.plural} in ${loc.name}, Cape Town`;
  if (cat) return `${cat.plural} in Cape Town`;
  return `Videographers & Film Crew in ${loc.name}, Cape Town`;
};

export default function DirectoryPage() {
  const { categorySlug, locationSlug } = useParams();
  const [data, setData] = useState(undefined);

  useEffect(() => {
    setData(undefined);
    axios.get(`${API}/directory`, { params: { category: categorySlug, location: locationSlug } })
      .then((r) => setData(r.data))
      .catch(() => setData(null));
  }, [categorySlug, locationSlug]);

  if (data === null) return <NotFound />;
  if (!data) return <div className="max-w-6xl mx-auto px-4 py-16"><div className="h-64 bg-zinc-900 skeleton" /></div>;

  const { category: cat, location: loc, profiles, related_categories } = data;
  const intro = (cat || loc)?.intro || cat?.description;

  return (
    <div className="py-12 px-4 md:px-8" data-testid="directory-page">
      <div className="max-w-6xl mx-auto">
        <nav aria-label="Breadcrumb" className="text-sm text-zinc-500 mb-6" data-testid="directory-breadcrumbs">
          <Link to="/" className="hover:text-orange-500">Home</Link>
          <span className="mx-2">›</span>
          {cat ? <Link to="/categories" className="hover:text-orange-500">Categories</Link> : <Link to="/locations" className="hover:text-orange-500">Locations</Link>}
          {cat && loc && (<><span className="mx-2">›</span><Link to={`/categories/${cat.slug}`} className="hover:text-orange-500">{cat.plural}</Link></>)}
          <span className="mx-2">›</span>
          <span className="text-zinc-300">{loc ? loc.name : cat.plural}</span>
        </nav>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl uppercase" data-testid="directory-title">{titleFor(cat, loc)}</h1>
        {intro && <p className="text-zinc-400 mt-4 max-w-3xl">{intro}</p>}

        {profiles.length ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10" data-testid="directory-grid">
            {profiles.map((p) => <ProfileCard key={p.profile_id} profile={p} />)}
          </div>
        ) : (
          <p className="text-zinc-500 mt-10" data-testid="directory-empty">No profiles listed here yet.</p>
        )}

        <h2 className="font-heading text-lg text-white mt-16 mb-4">Related categories</h2>
        <div className="flex flex-wrap gap-3">
          {related_categories.map((c) => (
            <Link key={c.slug} to={`/categories/${c.slug}`} className="px-3 py-1 border border-zinc-800 text-zinc-400 hover:border-orange-600 hover:text-white text-sm" data-testid={`related-category-${c.slug}`}>
              {c.plural}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
